(() => {
  const FOCUS_VARIANT_ID = 56892082684252;
  const TARGET_CODE = 'DRCIPRIANO';
  let busy = false;
  let observerTimer = null;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const normalize = value => String(value || '').trim().toUpperCase();

  function collectDiscountTitles(cart) {
    const titles = [];
    const add = value => { const v = normalize(value); if (v) titles.push(v); };
    (cart?.cart_level_discount_applications || []).forEach(d => { add(d?.title); add(d?.code); });
    (cart?.discount_applications || []).forEach(d => { add(d?.title); add(d?.code); });
    (cart?.items || []).forEach(item => {
      (item?.discounts || []).forEach(d => { add(d?.title); add(d?.code); });
      (item?.discount_allocations || []).forEach(a => {
        add(a?.discount_application?.title); add(a?.discount_application?.code);
        add(a?.source_discount_application?.title); add(a?.source_discount_application?.code);
      });
    });
    return [...new Set(titles)];
  }

  function domContainsCode(code) {
    const wanted = normalize(code);
    return Array.from(document.querySelectorAll('#CartDrawer, #main-cart-footer, #main-cart-items'))
      .some(el => normalize(el.textContent).includes(wanted));
  }

  const hasCode = (cart, code) => collectDiscountTitles(cart).includes(normalize(code)) || domContainsCode(code);
  const focusQuantity = cart => (cart?.items || []).reduce((sum, item) =>
    Number(item.variant_id) === FOCUS_VARIANT_ID ? sum + Number(item.quantity || 0) : sum, 0);

  async function getCart() {
    const response = await fetch(`${root()}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart load failed');
    return response.json();
  }

  function getSections() {
    try {
      if (window.Alpine && Alpine.store('xCartHelper')) return Alpine.store('xCartHelper').getSectionsToRender();
    } catch (_) {}
    return [];
  }

  function replaceSections(payload) {
    const sections = getSections();
    if (!payload?.sections || !sections.length || typeof window.getSectionInnerHTML !== 'function') return false;
    sections.forEach(section => {
      const element = document.querySelector(section.selector);
      if (element && payload.sections[section.id]) element.innerHTML = getSectionInnerHTML(payload.sections[section.id], section.selector);
    });
    try {
      const bubble = document.querySelector('#cart-icon-bubble span');
      if (bubble && window.Alpine && Alpine.store('xCartHelper')) Alpine.store('xCartHelper').currentItemCount = parseInt(bubble.innerHTML, 10) || 0;
    } catch (_) {}
    return true;
  }

  async function updateDiscount(code) {
    const sections = getSections();
    const body = { discount: code };
    if (sections.length) { body.sections = sections.map(s => s.id); body.sections_url = window.location.pathname; }
    const response = await fetch(`${root()}cart/update.js`, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    const payload = await response.json();
    if (!response.ok || payload?.status === 422) throw new Error(payload?.description || 'Discount failed');
    replaceSections(payload);
    document.dispatchEvent(new CustomEvent('eurus:cart:discount-code:change'));
  }

  async function addSecondFocus() {
    const sections = getSections();
    const body = { items: [{ id: FOCUS_VARIANT_ID, quantity: 1 }] };
    if (sections.length) { body.sections = sections.map(s => s.id); body.sections_url = window.location.pathname; }
    const response = await fetch(`${root()}cart/add.js`, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    const payload = await response.json();
    if (!response.ok || payload?.status === 422) throw new Error(payload?.description || 'Add to cart failed');
    const updated = replaceSections(payload);
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
    if (!updated) window.location.reload();
    try { if (window.Alpine && Alpine.store('xMiniCart')) Alpine.store('xMiniCart').openCart(); } catch (_) {}
  }

  function installStyles() {
    if (document.getElementById('myco-cipriano-style')) return;
    const style = document.createElement('style');
    style.id = 'myco-cipriano-style';
    style.textContent = `
      .myco-code-wrap{margin:12px 0 14px;padding:14px;border:1px solid rgba(var(--colors-text),.18);background:rgba(var(--background-color),1)}
      .myco-code-label{display:block;font-size:.95em;margin-bottom:8px}.myco-code-row{display:flex;gap:8px}
      .myco-code-input{min-width:0;flex:1;padding:11px 12px;border:1px solid rgba(var(--colors-text),.24);background:transparent;color:inherit;outline:none}
      .myco-code-status{font-size:.88em;margin-top:7px;min-height:1.2em}.myco-code-status.is-error{color:rgba(var(--color-error),1)}.myco-code-status.is-success{color:rgba(var(--color-success),1)}
      .myco-focus-upsell{margin-top:12px;padding:15px;border:1px solid rgba(var(--colors-text-link),.45);background:rgba(var(--colors-text-link),.07)}
      .myco-focus-upsell strong{display:block;margin-bottom:5px;font-size:1.05em}.myco-focus-upsell p{margin:0 0 11px;line-height:1.4}.myco-focus-upsell .button{width:100%;justify-content:center}
      .myco-code-wrap button[disabled],.myco-focus-upsell button[disabled]{opacity:.55;cursor:wait}
      @media(max-width:520px){.myco-code-row{flex-direction:column}.myco-code-row .button{width:100%;justify-content:center}}
    `;
    document.head.appendChild(style);
  }

  function boxState(cart) {
    return `${hasCode(cart, TARGET_CODE) ? 'target' : 'normal'}-${focusQuantity(cart)}`;
  }

  function createBox(cart) {
    const activeTarget = hasCode(cart, TARGET_CODE);
    const qty = focusQuantity(cart);
    const box = document.createElement('div');
    box.className = 'myco-code-wrap';
    box.dataset.mycoDiscountBox = '1';
    box.dataset.mycoState = boxState(cart);
    box.innerHTML = `
      <label class="myco-code-label">Hai un codice sconto?</label>
      <div class="myco-code-row">
        <input class="myco-code-input" type="text" autocomplete="off" placeholder="Inserisci il codice" aria-label="Codice sconto">
        <button type="button" class="button button-solid" data-myco-apply-code>Applica</button>
      </div>
      <div class="myco-code-status${activeTarget ? ' is-success' : ''}" aria-live="polite">${activeTarget ? 'Codice applicato.' : ''}</div>
      ${activeTarget && qty === 1 ? `<div class="myco-focus-upsell" data-myco-focus-upsell>
        <strong>Aggiungi un secondo FOCUS</strong>
        <p>Il tuo vantaggio del 30% vale anche sulla seconda confezione. <b>Nessun costo di spedizione aggiuntivo.</b></p>
        <button type="button" class="button button-solid" data-myco-add-focus>+ Aggiungi un altro FOCUS</button>
      </div>` : ''}`;
    return box;
  }

  async function render() {
    installStyles();
    let cart; try { cart = await getCart(); } catch (_) { return; }
    if (!cart || cart.item_count < 1) return;
    const state = boxState(cart);
    Array.from(document.querySelectorAll('button[name="checkout"]')).forEach(button => {
      const context = button.closest('#CartDrawer, #main-cart-footer, #main-cart-items, .cart__footer-wrapper') || button.parentElement?.parentElement;
      if (!context) return;
      const actionRow = button.parentElement;
      if (!actionRow?.parentElement) return;
      const existing = actionRow.parentElement.querySelector(':scope > [data-myco-discount-box]');
      if (!existing) actionRow.insertAdjacentElement('beforebegin', createBox(cart));
      else if (existing.dataset.mycoState !== state) existing.replaceWith(createBox(cart));
    });
  }

  document.addEventListener('click', async event => {
    const apply = event.target.closest('[data-myco-apply-code]');
    if (apply) {
      event.preventDefault(); if (busy) return;
      const box = apply.closest('[data-myco-discount-box]');
      const input = box?.querySelector('.myco-code-input');
      const status = box?.querySelector('.myco-code-status');
      const code = input?.value?.trim();
      if (!code) { if (status) { status.textContent = 'Inserisci un codice sconto.'; status.className = 'myco-code-status is-error'; } return; }
      busy = true; apply.disabled = true;
      if (status) { status.textContent = 'Verifica del codice…'; status.className = 'myco-code-status'; }
      try {
        await updateDiscount(code); await new Promise(r => setTimeout(r, 180));
        const cart = await getCart();
        if (!hasCode(cart, code)) throw new Error('invalid-code');
        if (status && document.body.contains(status)) { status.textContent = 'Codice applicato.'; status.className = 'myco-code-status is-success'; }
        await render();
      } catch (_) {
        if (status && document.body.contains(status)) { status.textContent = 'Il codice non è valido o non è applicabile al carrello.'; status.className = 'myco-code-status is-error'; }
      } finally { busy = false; if (document.body.contains(apply)) apply.disabled = false; }
      return;
    }

    const add = event.target.closest('[data-myco-add-focus]');
    if (add) {
      event.preventDefault(); if (busy) return;
      busy = true; add.disabled = true; const oldText = add.textContent; add.textContent = 'Aggiunta in corso…';
      try { await addSecondFocus(); await new Promise(r => setTimeout(r, 180)); await render(); }
      catch (_) { if (document.body.contains(add)) { add.textContent = 'Riprova'; setTimeout(() => { if (document.body.contains(add)) add.textContent = oldText; }, 1800); } }
      finally { busy = false; if (document.body.contains(add)) add.disabled = false; }
    }
  });

  const observer = new MutationObserver(() => { clearTimeout(observerTimer); observerTimer = setTimeout(render, 120); });
  function start() {
    installStyles(); render(); observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('eurus:cart:items-changed', render);
    document.addEventListener('eurus:cart:discount-code:change', render);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();